import Microgame from '../engine/Microgame.js';

export default class DrinkGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Bois !`, en: `Drink!`, es: `¡Bebe!` },
            controls: { fr: `Maintiens l'écran enfoncé pour boire le liquide`, en: `Hold the screen to drink the liquid`, es: `Mantén presionada la pantalla para beber` },
            objective: { fr: `Vide complètement le verre avant la fin du temps`, en: `Empty the glass completely before time ends`, es: `Vacía el vaso completamente antes de que se acabe` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M4.5 3h15M6 3v14c0 2 1 4 6 4s6-2 6-4V3"/></svg>`,
            actions: [
                { type: 'tap', x: 50, y: 58, duration: 120 },
                { type: 'wait', duration: 90 },
                { type: 'tap', x: 50, y: 58, duration: 120 },
                { type: 'wait', duration: 90 },
                { type: 'tap', x: 50, y: 58, duration: 120 },
                { type: 'wait', duration: 90 },
                { type: 'tap', x: 50, y: 58, duration: 120 },
                { type: 'wait', duration: 90 },
                { type: 'tap', x: 50, y: 58, duration: 120 },
                { type: 'wait', duration: 90 },
                { type: 'tap', x: 50, y: 58, duration: 120 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.liquid = null;
        this.level = 100;
        this.gulpSize = 15;

        // +50ms at max speed
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeed = 1 + (speedMult - 1) * (2.95 / 3);
        this.duration = 3000 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "CHUG!";

        // Glass (Secondary)
        const glass = document.createElement('div');
        glass.style.position = 'absolute';
        glass.style.width = '100px';
        glass.style.height = '160px';
        glass.style.border = `5px solid ${this.secondaryColor}`;
        glass.style.borderTop = 'none';
        glass.style.borderRadius = '0 0 15px 15px';
        glass.style.left = '50%';
        glass.style.top = '50%';
        glass.style.transform = 'translate(-50%, -50%)';
        glass.style.overflow = 'hidden';
        glass.style.boxShadow = `0 0 20px ${this.secondaryColor}`;
        this.container.appendChild(glass);

        // Liquid (Primary)
        this.liquid = document.createElement('div');
        this.liquid.style.position = 'absolute';
        this.liquid.style.width = '100%';
        this.liquid.style.height = '100%';
        this.liquid.style.background = this.primaryColor;
        this.liquid.style.bottom = '0';
        this.liquid.style.left = '0';
        this.liquid.style.transition = 'height 0.1s';
        glass.appendChild(this.liquid);

        // Bubbles/Foam
        const foam = document.createElement('div');
        foam.style.position = 'absolute';
        foam.style.width = '100%';
        foam.style.height = '10px';
        foam.style.background = 'rgba(255,255,255,0.5)';
        foam.style.top = '0';
        foam.style.left = '0';
        this.liquid.appendChild(foam);

        this.onDown = this.onDown.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onDown);
    }

    onDown() {
        if (!this.active || this.won) return;

        this.level -= this.gulpSize;

        // Visual feedback
        this.liquid.style.height = `${Math.max(0, this.level)}%`;

        // Shake effect
        this.container.style.transform = `translate(${Math.random() * 10 - 5}px, ${Math.random() * 10 - 5}px)`;
        setTimeout(() => this.container.style.transform = 'none', 50);

        if (this.level <= 0) {
            this.win();
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
    }
}
